import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetCalendarEventsRequestES extends BaseServiceRequest {
  constructor(basicInfoObj) {
    super();
    super.addRequestUri("esbasiccalevent.pb");
    super.addPathParameter(basicInfoObj.listId.toString());
    this.methodType = HttpMethodType.POST;
    super.setContent(basicInfoObj.encode());
  }

  getMethod() {
    return this.methodType;
  }

  getSubSystem() {
    return SubSystemType.LIST;
  }

  getMessageName() {
    return "ListCatalogResponse";
  }
}

export default GetCalendarEventsRequestES;
